function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 0C7.60156 0 5.12695 1.02539 3.07617 3.07617C1.02539 5.12695 0 7.60156 0 10.5C0 13.3984 1.02539 15.873 3.07617 17.9238C5.12695 19.9746 7.60156 21 10.5 21C13.3984 21 15.873 19.9746 17.9238 17.9238C19.9746 15.873 21 13.3984 21 10.5C21 7.60156 19.9746 5.12695 17.9238 3.07617C15.873 1.02539 13.3984 0 10.5 0ZM1.76367 10.5C1.76367 8.09375 2.61816 6.03613 4.32715 4.32715C6.03613 2.61816 8.09375 1.76367 10.5 1.76367C12.6602 1.76367 14.4922 2.43359 15.9961 3.77344L3.77344 15.9961C2.43359 14.4922 1.76367 12.6602 1.76367 10.5ZM10.5 19.2363C8.33984 19.2363 6.50781 18.5664 5.00391 17.2266L17.2266 5.00391C18.5664 6.50781 19.2363 8.33984 19.2363 10.5C19.2363 12.9062 18.3818 14.9639 16.6729 16.6729C14.9639 18.3818 12.9062 19.2363 10.5 19.2363Z",
  fill: "#FA4339"
});

function SvgNotAllow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAllow);
export default __webpack_public_path__ + "static/media/not-allow.90350c58.svg";
export { ForwardRef as ReactComponent };